// extracted by mini-css-extract-plugin
export default {"root":"StuSectionPicker_root__xRe1Z","arrBtn":"StuSectionPicker_arrBtn__6jtEA","icon":"StuSectionPicker_icon__yvgAI"};